<template>
  <a-page
    :image_source="image_source"
    :image_height="image_height"
    :color="isGroup ? '#ffffff' : '#f1f1f1'"
  >
    <template v-slot:header_options>
      <a-btn-pdf
        v-if="has_permission('export_pdf')"
        :config="pdf_config"
        class="mr-4"
      ></a-btn-pdf>
      <div v-if="!isGroup && show_production_mode" style="max-width: 200px;">
        <v-select
          v-model="commission"
          :items="commission_types"
          item-text="name"
          item-value="id"
          :label="$t('billing_type')"
          :rules="[v => !!v || $t('required')]"
          class="mr-4"
          color="#fff"
          rounded
          outlined
          dense
          hide-details
        >
        </v-select>
      </div>
      <div v-if="!isGroup && tabs.length > 0" style="max-width: 210px;">
        <v-select
          v-model="tab_view"
          :items="tabs"
          item-value="id"
          :label="$t('viewType')"
          class="mr-2"
          color="#fff"
          rounded
          outlined
          dense
          hide-details
          :full-width="true"
        >
          <template v-slot:[`item`]="{ item }">
            <v-icon>
              {{ item.icon }}
            </v-icon>
            <span class="ml-2">
              {{ item.name }}
            </span>
          </template>
          <template v-slot:[`selection`]="{ item }">
            <v-icon>
              {{ item.icon }}
            </v-icon>
            <span class="ml-2">
              {{ item.name }}
            </span>
          </template>
        </v-select>
      </div>
      <a-rms-range-selector
        v-if="!isGroup"
        ref="a-rms-range-selector"
        :event_period="[strategy_from, strategy_to]"
        @updatePeriod="updateRange"
        class="mr-2"
      >
      </a-rms-range-selector>
      <a-rms-import-dates
        ref="rms_import_dates"
        v-if="!isGroup"
      ></a-rms-import-dates>
    </template>
    <a-hotel-selector-rms
      ref="a-hotel-selector-rms"
      v-if="isGroup"
    ></a-hotel-selector-rms>
    <rms-strategy-app
      v-else
      ref="rms-strategy-app"
      :event_period="[strategy_from, strategy_to]"
      :tab_view="tab_view"
    ></rms-strategy-app>
  </a-page>
</template>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import aPage from "@/components/aPage";
import rmsStrategyApp from "@/components/app/clicktotravel/rmsStrategyApp";
import aRmsRangeSelector from "@/components/rms/aRmsRangeSelector";
import aHotelSelectorRms from "@/components/selector/aHotelSelectorRms";
import aRmsImportDates from "@/components/rms/aRmsImportDates";
import aBtnPdf from "@/components/aBtnPdf";

export default {
  name: "rms-strategy",
  components: {
    aPage,
    rmsStrategyApp,
    aRmsRangeSelector,
    aHotelSelectorRms,
    aRmsImportDates,
    aBtnPdf
  },
  data: () => ({
    image_source: "/img/header.jpg",
    event_period: [],
    tab_view: "table"
  }),
  methods: {
    updateRange(v) {
      let range = JSON.parse(JSON.stringify(v));
      this.strategy_from = range[0];
      this.strategy_to = range[1];
    },
    getFriendlyDate(date) {
      return Vue.moment(date).format("DD/MM/YYYY");
    }
  },
  computed: {
    tabs() {
      return [
        { name: this.$t("resumeTable"), id: "table", icon: "mdi-table-large" },
        { name: this.$t("charts"), id: "chart", icon: "mdi-chart-bar" }
      ];
    },
    isGroup() {
      return this.current_hotel && this.current_hotel.children_number > 0;
    },
    image_height() {
      return !this.isGroup ? 105 : 200;
    },
    show_production_mode() {
      return this.current_user && this.current_hotel
        ? this.current_user.permissions.rms_production_mode &&
            this.current_hotel.permissions.rms_production_mode
        : false;
    },
    strategy_from: {
      get() {
        return this.$store.state.rms.strategy_from;
      },
      set(value) {
        this.$store.dispatch("setStrategyFrom", value);
      }
    },
    strategy_to: {
      get() {
        return this.$store.state.rms.strategy_to;
      },
      set(value) {
        this.$store.dispatch("setStrategyTo", value);
      }
    },
    commission: {
      get() {
        return this.$store.state.rms.year_sales_commission;
      },
      set(value) {
        this.$store.dispatch("setRmsYearSalesCommission", value);
      }
    },
    pdf_config() {
      return {
        filename:
          this.$t("revenue_strategy") +
          " - " +
          this.current_hotel.name +
          " -- " +
          this.getFriendlyDate(this.strategy_from) +
          " - " +
          this.getFriendlyDate(this.strategy_to),
        elements: [
          {
            id: "rms-strategy-table",
            is_table: true
          },
          {
            id: "rms-strategy-chart",
            is_table: false
          }
        ],
        hotel_name: this.current_hotel.name,
        section_name: this.$t("revenue_strategy")
      };
    },
    ...mapState({
      available_permissions: state => state.user.available_permissions
    }),
    ...mapGetters({
      current_hotel: "current_hotel",
      current_user: "current_user",
      has_permission: "has_permission",
      commission_types: "commission_types"
    })
  },
  mounted() {
    // Initialize selector
    if (!this.strategy_from) {
      this.strategy_from = Vue.moment()
        .startOf("month")
        .format("YYYY-MM-DD");
    }
    if (!this.strategy_to) {
      this.strategy_to = Vue.moment()
        .endOf("month")
        .format("YYYY-MM-DD");
    }
  },
  created() {
    if (this.show_production_mode && this.commission === "") {
      this.commission = this.commission_types[0].id;
    }
  }
};
</script>
